// src/navigation/tabs/TabsTypes.ts

import { IconDefinition } from "@fortawesome/fontawesome-svg-core";

export interface TabItem {
  /** Visible label on the tab */
  label: string;
  /** React‑Router path to match */
  path: string;
  /** Optional FontAwesome icon  */
  icon?: IconDefinition;
  /** Optional accent color for the tab (e.g. border / icon tint) */
  color?: string;
}

export enum Interval {
  HOUR,
  DAY,
}

export const getIntervalString = (interval: Interval): string =>
  interval === Interval.HOUR ? "hour" : "day";
